<template>
	<div class="division-component">
		<div v-if="reduce.length" v-html="reduce"></div>
		<div v-if="divisor == 1">
			{{ read_notation(dividend) + ' ÷ ' + read_notation(divisor) + ' = ' + read_notation(dividend) }}
		</div>
		<template v-else-if="isDecimal">
			<div class="divide-bydecimal">
				<p class="divide-by-decimal-litteral">
					<span class="dividend">{{ dividend }}</span>
					<span class="operator">÷</span>
					<span class="divisor">{{ divisor }}</span>
					<span class="equal">=</span>
					<span class="unknow-result">?</span>
				</p>
				<h6 class="divide-by-decimal-title">How do you make division when divisor is decimal?</h6>
				<ol class="divide-by-decimal-steps steps">
					<li class="step">Turn <span class="divisor-original text-info">{{ propDivisor }}</span> into the whole product <span class="whole-divisor text-info">{{ divisorInt }}</span> by moving the decimal point <span class="number-move-decimal text-info">{{ numberMove }}</span> place to the right.</li>
					<li class="step">At the same time, move the decimal point in <span class="original-dividend text-info">{{ propDividend }}</span> <span class="number-moves text-primary">{{ numberMove }}</span> place to the right.</li>
					<li class="step">Put your decimal point in the quotient directly above where it falls in <span class="real-dividend text-info">{{ dividendMoved }}</span></li>
					<li class="step">
						Then make a normal division with the new values:
						<p class="step-demo ml-3">
							<division :prop-divisor="divisorInt" :prop-dividend="dividendMoved" :operation="operation" :int="int" :floating="floating" />
						</p>
					</li>
				</ol>
			</div>
		</template>
		<template v-else-if="is_short">
			<component :is="sentenceDivision" />
		</template>
		<template v-else>
			<div class="demonstration">
				<div class="block-component">
					<div class="result">
						<span>{{ result_ }}</span>
					</div>
					<div class="operation-div">
						<div class="divisor">{{ divisor }}</div>
						<div class="steps">
							<div class="dividend">{{ dividend }}<span class="emprunt" v-show="completeDividend.length > 0"><span v-if="parseInt(dividend) == dividend">.</span>{{ completeDividend }}</span></div>
							<div>
								<div v-for="(step, i) in stepsResult" :class="['step', `move-${step.gap.step} step-${i}`]">
									<div :class="['soustraction-op-1']">
										<span class="minus minus-sign">-</span>
										<!-- <span :class="['product', `product-${step.gap.prod}`]">{{ step.product }}</span> -->
										<span :class="['product', '']">{{ step.product }}</span>
									</div>
									<hr class="line">
									<!-- <div :class="['difference', `diff-${step.gap.remainder}`]"> -->
									<div :class="['difference']">
										<span class="remainder" >{{ step.remainder }}</span><span class="emprunt">{{ step.loan }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="remainder-division" v-if="remainder > 0 && parseInt(result_) == result_">R{{ remainder }}</div>
			</div>
		</template>
	</div>
</template>

<script type="text/javascript">
	const $operations = require("../scripts/variables").operations;
	const space = "0";
	import BaseExerciseMixin from '../../js/BaseExerciseMixin';
	import ShortDivision from './ShortDivisionComponent.vue';
	import UFCT from 'usefull-functions';
	import { Operation } from '../scripts/QuizClass';
	export default {
		name: "division",
		components: { ShortDivision },
		mixins: [ BaseExerciseMixin ],
		props: {
			propDivisor: { required: true, validator(val) {return val > 0; } },
			propDividend: { required: true },
			int: { type: Boolean, required: false, default: true} ,
			floating: { type: [String, Number, Boolean], default: '0' },
			operationProp: { type: [String, Object, Array], required: false, default: () => ({}) }
		},
		data(){
			let operation = new Operation(Object.assign(this.operationProp, {
					operands: [this.propDividend, this.propDivisor],
					operator: '/',
					isFloat: !!this.floating || this.operationProp.isFloat,
					floating: this.floating
				})
			);
			return {
				reduce: '',
				space: 0.6,
				isDecimal: false,
				stepsResult: [],
				result: operation.answerOperation,
				gap_result: this.propDivisor.toString().length,
				remainder: this.propDividend % this.propDivisor,
				completeDividend: '',
				dividend: Number,
				divisor: Number,
				dividendMoved: this.propDividend,
				numberMove: Number,
				divisorInt: Number,
				float: this.floating || operation.floating,
				operation: operation
			}
		},
		beforeCreate(){
		},
		created(){

			// console.log("DivisionComponent created with props:",this.$props);
			this.dividend = Number(this.alt_0(Number(this.propDividend), this.operation.operands[0], undefined).toString());
			this.divisor = Number(this.alt_0(Number(this.propDivisor), this.operation.operands[1], 0));
			let float = [0, '0', false].includes(this.float) ? 0 : (Number(this.float) == this.float ? this.float : this.divisor.toString().length - 1);
			if (this.isInt) {
				this.result = parseInt(this.result);
			}
			if(this.divisor == 0){
				console.error("Division impossible, parametters provided:", this.$props);
				throw new Error('Error on division: Division by zero is not possible with parameters:');
			}
			if(this.dividend == undefined || Number(this.dividend) != this.dividend || Number(this.divisor) != this.divisor){
				console.error("Division impossible, parametters provided:", this.$props);
				throw new Error('Error on division: Dividend or divisor value is not valid.');
			}
			this.isDecimal = this.divisor % 1 > 0;
			if (this.isDecimal) {
				let divisorInt = parseInt(this.divisor.toString().replace('.', '')),
					numberMove = Number(this.divisor).toString().split('.')[1].length,
					dividendDecimalLength = parseInt(this.dividend) == this.dividend ? 0 : this.dividend.toString().split('.')[0].length,
					dividendMoved = Number((this.dividend.toString() * Math.pow(10, numberMove)).toFixed(dividendDecimalLength)),
					dividend = this.dividendMoved;
				this.divisorInt = divisorInt;
				this.numberMove = numberMove;
				this.dividendMoved = dividendMoved;
				return;
			}
			let dividend = this.dividend, divisor = this.divisor, result = '', decals = '';
			while(dividend % 10 == 0 && divisor % 10 == 0){
				dividend = dividend / 10;
				divisor = divisor / 10;
				decals = decals + '0';
			}
			if (dividend != this.dividend) {
				decals = UFCT.tag('span', decals, {class: 'reduction-zeros text-danger'})
				this.reduce = `${this.read_notation(dividend)}${decals} ÷ ${this.read_notation(divisor)}${decals} = ${dividend} ÷ ${divisor}`;
				this.dividend = dividend;
				this.divisor = divisor;
			}
			dividend = dividend.toString(); divisor = divisor.toString();
			let stepsResult = [],
				current_dividend = dividend.slice(0, divisor.length);
			if(!this.int) {
				current_dividend = parseInt(current_dividend) * 100;
			}
			let remainder = (current_dividend % divisor).toString(),
				current_dividend_length = parseInt(current_dividend.replace('.', '')).toString().length,
				result_length = this.result.toString().replace('.', '').length,
				quotient = parseInt(current_dividend / divisor).toString(),
				loan = dividend.replace('.', '').charAt(current_dividend_length),
				product = (quotient * divisor).toString(),
				gap_rest = current_dividend_length - remainder.length,
				gap_product = current_dividend.length - product.length,
				complete_string = current_dividend.replace(/./gi, '0'),
				isEnd = false, gap_step = current_dividend_length - remainder.length;
			if(quotient > 0) {
				gap_rest = current_dividend_length - remainder.length;
				this.stepsResult.push({
					product: (complete_string + product.toString()).slice(-current_dividend_length),
					remainder: (dividend.charAt(current_dividend_length) == '.' ? ' ' : '') + (complete_string.toString() + remainder.toString()).slice(-current_dividend_length),
					quotient: quotient,
					loan: loan,
					gap: {
						remainder: gap_rest,
						prod: gap_product,
						step: 0
					}
				});
			} else {
				this.gap_result++;
			}
			let i = current_dividend_length;
			while(!this.isEnd){
				let nextDigit = dividend.replace('.', '').charAt(i + 1), old_remainder = remainder;
				if(dividend.charAt(i) == '.'){
					i++;
				}
				current_dividend = old_remainder.toString() + (dividend.charAt(i) || '0');
				current_dividend_length = parseInt(current_dividend).toString().length;
				quotient = parseInt(current_dividend / divisor);
				product = (quotient * divisor).toString();
				remainder = (current_dividend % divisor).toString();
				gap_product = gap_product + (product == 0 ? 0 : (current_dividend.length - product.length)) + (Number(current_dividend) == 0 ? 1 : 0);
				gap_rest = product.length
				if(dividend.charAt(i - 1) == '.' || (dividend.length == i && !this.result_.includes('.'))){
					quotient = '.' + quotient;
				}
				let lenght_step_result = this.stepsResult.push({
					product: (complete_string + product.toString()).slice(-current_dividend.length),
					remainder: (complete_string.toString() + remainder.toString()).slice(-current_dividend.length),
					quotient: quotient,
					loan: '',
					gap: {
						remainder: current_dividend.length - remainder.length /*current_dividend_length - remainder.toString().length*/,
						prod: current_dividend.length - product.length /*gap_product*/,
						step: gap_step
					}
				});
				gap_step += current_dividend.length - remainder.length;
				if (!this.isEnd) {
					if (!nextDigit) {
						this.completeDividend = `${this.completeDividend}0`
					} else {

					}
					loan = nextDigit || '0';
					this.stepsResult[lenght_step_result - 1].loan = loan;
					i++;
				}
			}
			this.remainder = parseInt(remainder);
		},
		computed:{
			result_() {
				return this.stepsResult.map(el => el.quotient).join("");
			},
			is_short(){
				if(typeof this.operation == 'object'){
					return this.operation.hasOwnProperty('type') && this.operation.type == 'short';
				}
				return false;
			},
			isInt() {
				if (this.operation.isFloat) {
					return false;
				}
				if (this.floating > 0) return false;
				return parseInt(this.operation.answerOperation) == Number(this.operation.answerOperation);
				return this.propDivisor == parseInt(this.propDivisor) && this.propDividend == parseInt(this.propDividend);
			},
			isEnd() {
				if (this.dividend % this.divisor == 0) {
					return this.dividend == this.result_ * this.divisor;
				}
				let dividend = this.dividend * Math.pow(10, this.divisor.length - 1);
				if (!this.isInt && dividend % this.divisor == 0) {
					return this.dividend == this.result_ * this.divisor;
				}
				return this.result.toString().length == this.result_.toString().length;
			},
			sentenceDivision() {
				return {
					template: UFCT.tag('span', `${this.read_notation(this.dividend)} ÷ ${this.read_notation(this.divisor)} = ${this.result}`, { class: 'sentence-division' }) ,
					data() {
						return {}
					},
					name: "SentenceDivision"
				}
			}
		},
		methods:{
			count(n){
				return n.getLength();
			},
			ml(len){
				return {'margin-left': `${len}ch`};
			}
		}
	};
</script>

<style lang="scss">
	.division-component{
		display: inline-block;
		position: relative;
		.demonstration{
			position: relative;
		}
		.block-component{
			.result{
				text-align: right;
				margin-bottom: 0.2rem;
				font-size: inherit !important;
				// padding: 0 0.5rem 0;
			}
			& > div.operation-div{
				display: flex;
				justify-content: flex-end;
				.divisor{
					margin-right: 0.5ch;
					margin-top: -1ch;
				}

				.steps{
					line-height: 130%;
					// padding: 0 0.5rem;
					.dividend{
						border-top: 1px solid black;
						border-left: 1px solid black;
						margin-top: -0.5rem;
					}
					.step {
						line-height: 1;
						position: relative;
							@for $i from 0 through 10 {
								&.move-#{$i} {
									padding-left: #{$i}ch;
								}
							}
						.soustraction-op-1 {
							position: relative;
							// margin-top: 0.5ch;
							.minus-sign {
								position: absolute;
								left: -1ch;
							}
							.product {
								color:#ffa500;
								// margin-top: -0.5rem;
								&.step-0 {

								}
								@for $i from 0 through 10 {
									&.product-#{$i} {
										margin-left: #{$i}ch;
									}
								}
							}
						}
						.difference {
							@for $i from 0 through 10 {
								&.diff-#{$i} {
									margin-left: #{$i}ch;
								}
							}
						}
					}
					.line{
						border-bottom:1px solid grey;
						// margin-top: -0.30rem!important;
					}
					.minus{
						// margin-left: -0.9rem!important;
					}
					& > div {
						padding: 0 0 0 1ch;
						// margin-top: -0.5rem;
						text-align: left;
						.product{
								// @extend .text-danger;
							}
						.remainder{
							color: #22D3EE;
						}
						.emprunt{
								color: blue;
							}

						.difference{
							// margin-left: 0.65rem;
						}

						&:last-child{
							.remainder{
								color:#EF4444;
							}
						}
						&:first-child{
							.minus{
							}
						}
					}
				}
			}
		}
		.remainder-division{
			position:absolute;
			top:0;
			right: -6rem;
		}
	}
	.reduction-zeros {
		text-decoration: line-through;
	}
</style>